var _defs, _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 671.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115,175.7c-38.8,38.8-38.8,101.7,0,140.5l60.7-60.7c-5.2-5.2-5.2-13.7,0-19,49.5-49.5,129.7-49.5,179.2,0l60.7-60.7c-83-83-217.6-83-300.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.4,495.3c-5.2,5.2-13.7,5.2-19,0-49.5-49.5-49.5-129.7,0-179.2l-60.7-60.7c-83,83-83,217.6,0,300.6,38.8,38.8,101.7,38.8,140.5,0l-60.7-60.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M556.1,354.9l-60.7,60.7c5.2,5.2,5.2,13.7,0,19-49.5,49.5-129.7,49.5-179.2,0l-60.7,60.7c83,83,217.6,83,300.6,0,38.8-38.8,38.8-101.7,0-140.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M495.3,115c-38.8-38.8-101.7-38.8-140.5,0l60.7,60.7c5.2-5.2,13.7-5.2,19,0,49.5,49.5,49.5,129.7,0,179.2l60.7,60.7c83-83,83-217.6,0-300.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M937.4,306.2c-32.2,0-61.7,11.8-84.3,31.4-10.2-18.7-30.1-31.4-52.9-31.4s-55.5,9.5-76.9,25.4v-19.6h-52.2v183.2h52.2v-60c0-42.5,34.5-76.9,76.9-76.9s8.2,3.6,8.2,8.2v128.8h52.2v-60c0-42.5,34.5-76.9,76.9-76.9s8.2,3.6,8.2,8.2v128.8h52.2v-128.8c0-33.3-27-60.3-60.3-60.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1346.6,306.2c-28.8,0-55.5,9.5-76.9,25.4v-19.6h-52.2v183.2h52.2v-60c0-42.5,34.5-76.9,76.9-76.9s8.2,3.6,8.2,8.2v128.8h52.2v-128.8c0-33.3-27-60.3-60.3-60.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1107.4,306.2c-53.8,0-97.5,43.6-97.5,97.5s43.6,97.5,97.5,97.5,97.5-43.6,97.5-97.5-43.6-97.5-97.5-97.5ZM1107.4,449c-25,0-45.3-20.3-45.3-45.3s20.3-45.3,45.3-45.3,45.3,20.3,45.3,45.3-20.3,45.3-45.3,45.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1816.6,306.2c-53.8,0-97.5,43.6-97.5,97.5s43.6,97.5,97.5,97.5,97.5-43.6,97.5-97.5-43.6-97.5-97.5-97.5ZM1816.6,449c-25,0-45.3-20.3-45.3-45.3s20.3-45.3,45.3-45.3,45.3,20.3,45.3,45.3-20.3,45.3-45.3,45.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 1573.4,
    y: 312.1,
    width: 52.2,
    height: 183.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1599.5,
    cy: 275.1,
    r: 26.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1651.6,509.2c0,4.5-3.6,8.2-8.2,8.2-12.4,0-24.2-3-34.6-8.2v55.7c11,3.1,22.6,4.7,34.6,4.7h0c33.3,0,60.3-27,60.3-60.3v-197.1h-52.2v197.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1677.7,
    cy: 275.1,
    r: 26.1,
    transform: "translate(-22.4 272.3) rotate(-9.2)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1175.2,172.8c-15.9,0-30.3,5.8-41.5,15.4-5-9.2-14.8-15.4-26-15.4s-27.3,4.6-37.8,12.5v-9.6h-25.6v90.1h25.6v-29.5c0-20.9,16.9-37.8,37.8-37.8s4,1.8,4,4v63.3h25.6v-29.5c0-20.9,16.9-37.8,37.8-37.8s4,1.8,4,4v63.3h25.6v-63.3c0-16.4-13.3-29.7-29.7-29.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "764 198.5 764 172.8 696.7 172.8 671.1 172.8 671.1 198.5 671.1 206.5 671.1 232.1 671.1 265.8 696.7 265.8 696.7 232.1 747 232.1 747 206.5 696.7 206.5 696.7 198.5 764 198.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M891.6,185.3v-9.6h-25.6v90.1h25.6v-29.5c0-20.9,16.9-37.8,37.8-37.8v-25.6c-14.2,0-27.3,4.6-37.8,12.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1004.1,175.7v26.6c0,20.9-16.9,37.8-37.8,37.8s-4-1.8-4-4v-60.4h-25.6v60.4c0,16.4,13.3,29.7,29.7,29.7s27.3-4.6,37.8-12.5v12.5h25.6v-90.1h-25.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M811.8,172.8c-26.5,0-47.9,21.5-47.9,47.9s21.5,47.9,47.9,47.9,47.9-21.5,47.9-47.9-21.5-47.9-47.9-47.9ZM811.8,243c-12.3,0-22.3-10-22.3-22.3s10-22.3,22.3-22.3,22.3,10,22.3,22.3-10,22.3-22.3,22.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1507.5,267l-52.2,10.2v34.9h-34.9v46.3h34.9v76.6c0,33.3,27,60.3,60.3,60.3h0c12,0,23.6-1.7,34.6-4.7v-55.7c-10.4,5.2-22.1,8.2-34.6,8.2s-8.2-3.6-8.2-8.2v-76.6h42.7v-46.3h-42.7v-45.1Z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 2000,
    height: 671.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.c80381f3d916c5eb9286ac5701357447.svg";
export { ForwardRef as ReactComponent };